import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Settings } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useOnClickOutside } from '../../hooks/useOnClickOutside';
import { logger } from '../../utils/logger';

export default function ProfileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  useOnClickOutside(menuRef, () => setIsOpen(false));

  const handleLogout = async () => {
    try {
      logger.info('User logging out', { email: user?.email });
      await signOut();
      navigate('/');
    } catch (error) {
      logger.error('Logout failed', error);
    }
  };

  const handleSettings = () => {
    setIsOpen(false);
    navigate('/account/settings');
  };

  const initial = user?.email?.charAt(0).toUpperCase() || 'U';

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center hover:bg-blue-700 transition-colors"
        aria-label="Open profile menu"
      >
        {initial}
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-1 animate-fadeIn">
          <div className="px-4 py-2 text-sm text-gray-600 border-b">
            {user?.email}
          </div>
          <button
            onClick={handleSettings}
            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center"
          >
            <Settings className="w-4 h-4 mr-2" />
            Account Settings
          </button>
          <button
            onClick={handleLogout}
            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center border-t"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
}